<template>
  <div class="classManger">
    <!-- <el-aside class="sidebar">
      <el-button
        type="text"
        style="float:right;margin-top:5px;margin-right:10px"
        @click="openCampusDialog(1)"
        icon="el-icon-plus"
      >添加省份</el-button>
    </el-aside> -->
    <el-card>
      <span
        style="
          color: rgb(182 182 182);
          margin-bottom: 1rem;
          display: inline-block;
        "
        >学员可以通过网校/小程序/APP/查看以下的考试指南，请教务老师及时更新</span
      >
      <el-skeleton v-if="loading" :rows="6" animated />
      <div v-else>
        <div
          v-for="(item1, index1) in tableData"
          :key="item1.id"
          class="subject"
        >
          <div class="title-box mg-4 lg">
            <div class="decorate flex"></div>
            <div class="title flex" style="font-weight: bold">
              {{ item1.name }}
            </div>
            <div
              @click="
                editGoods('add', { dictionaryId: item1.id, id: item1.id })
              "
              class="plus flex"
              style="color: #4c94ff; cursor: pointer"
            >
              <i class="el-icon-plus"></i><span>指南</span>
            </div>
          </div>
          <div class="goods-box">
            <!-- <div class="goods"></div> -->
            <el-row :gutter="20">
              <el-col
                class="mg-4"
                v-for="item2 in item1.subjectGuides"
                :key="item2.id"
                :span="5"
              >
                <div class="button_box">
                  <el-button
                    @click="
                      editGoods('edit', {
                        id: item2.id,
                        dictionaryId: item2.dictionaryId,
                      })
                    "
                    >{{ item2.guideName
                    }}<i
                      class="el-icon-edit-outline el-icon--right editicon"
                    ></i>
                  </el-button>
                  <el-popconfirm
                    title="确定删除吗？"
                    @confirm="
                      deleteItem(
                        [{ id: item2.id.toString() }],
                        item1.id.toString(),
                        item2.id.toString()
                      )
                    "
                  >
                    <el-button
                      slot="reference"
                      size="mini"
                      class="delete_btn"
                      type="danger"
                      icon="el-icon-delete"
                      circle
                    ></el-button>
                  </el-popconfirm>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true, //表格是否加载中
      inp: "", //输入框绑定的值
      visible: false,
      tableData: [],
      queryData: {},
      currentPage: 1,
      pageSize: 10,

      total: 0,
    };
  },
  methods: {
    deleteItem(data, parentId, id) {
      console.log("确定删除了", data);

      this.api.guideEx.deleteSubjectGuide(data).then((result) => {
        if (result.success) {
          this.$message.success(result.message);
          /*  const parent = tableData.find((obj) => obj.id == parentId);
          const index = parent.subjectGuides.findIndex((obj) => obj.id == id);
          parent.subjectGuides.splice(index, 1);
          this.$forceUpdate(); */
          this.getPageList();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    //跳转新增编辑
    editGoods(type, obj) {
      //add 和 edit
      //  this.$router.push("/addGuide", type);
      if (type === "add") {
        this.$router.push({
          path: "/addGuide",
          query: { type, dictionaryId: obj.dictionaryId, id: obj.id },
        });
      } else if (type === "edit") {
        this.$router.push({
          path: "/addGuide",
          query: { type, id: obj.id, dictionaryId: obj.dictionaryId },
        });
      }
    },

    getPageList() {
      this.loading = true;
      this.tableData = [];
      let data = [
        {
          title: "会计",
          children: [
            { title: "中级会计职称", id: 1 },
            { title: "税务师TA", id: 2 },
            { title: "中级会计职称", id: 3 },
            { title: "税务师TA", id: 4 },
            { title: "中级会计职称", id: 5 },
            { title: "税务师TA", id: 6 },
            { title: "中级会计职称", id: 7 },
            { title: "税务师TA", id: 8 },
            { title: "中级会计职称", id: 9 },
            { title: "税务师TA", id: 10 },
          ],
        },
        {
          title: "电脑",
          children: [
            { title: "计算机一级", id: 2 },
            { title: "计算机二级", id: 3 },
          ],
        },
      ];
      //this.tableData = data;
      this.api.guideEx
        .getDictionaryGuide(data)
        .then((result) => {
          if (result.success) {
            this.tableData = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    addCampusDialog: function (newVal) {
      if (!newVal) {
        this.refs.addCampusForm.resetFields();
        this.addCampusForm.parentId = "";
        this.addCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
    editCampusDialog: function (newVal) {
      if (!newVal) {
        this.refs.editCampusForm.resetFields();
        this.editCampusForm.parentId = "";
        this.editCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
  },
  created() {
    // this.getCampusList();
    this.getPageList();
  },
  mounted() {
    /*   window.onresize = () => {
      this.setaddDialogwidth();
    }; */
  },
};
</script>
<style scoped>
.title-box {
  display: relative;
  border-left-width: 5px;
  border-left-color: #4c94ff;
}
.title-box .flex {
  display: inline-block;
}
.editicon {
  float: right;
  position: relative;
  top: 1px;
}

.decorate {
  position: relative;
  top: 3px;
  left: 0;
  height: 16px;
  width: 3px;
  background-color: #4c94ff;
}
.title-box::before {
  content: "";
  display: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #4c94ff;
}
.mg-4 {
  margin-bottom: 1rem;
}
.lg {
  font-weight: 700;
  font-size: 1.5rem;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.button_box {
  /*   float: left; */
  /*  display: inline-block; */
  display: flex;
  align-items: center;
  position: relative;
}
.delete_btn {
  margin-left: 0.3rem;
  position: absolute;
  display: none;

  top: 50%;
  transform: translateY(-50%);
}
.button_box:hover .delete_btn {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/registerGuide/index.vue